import { ThemeProvider } from '@mui/material/styles';
import { getTheme } from '@parsys/frontend_library';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import ProfileDropdown from './ProfileDropdown';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';
import { userUpdate } from 'FRONTEND/reducers/userSlice';
import { formatExpert } from 'FRONTEND/utils/backendApi/expert/expert';
import { THEME_APP_NAME } from 'FRONTEND/utils/constants';
import { RIGHTS } from 'FRONTEND/utils/rights';

import './index.css';

// Mark strings as needing to be translated (so that pybabel will extract them),
// but do not execute the translation as it will be done in the component.
const _ = (key) => key;
export default (element, store) => {
  if (!store.getState().user.isInit) {
    const managedExpertsList = JSON.parse(element.dataset.managedExperts)?.map(formatExpert) ?? [];
    const rightsByTenant = JSON.parse(element.dataset.rights) ?? {};
    // Flatten the rights by tenant to get the full list of rights for the user, and remove duplicates.
    const rights = Array.from(new Set(Object.values(rightsByTenant).flat()));
    const currentUser = {
      alias: element.dataset.alias || '',
      picture: element.dataset.picture,
      id: element.dataset.id,
      login: element.dataset.login,
      firstName: element.dataset.firstName,
      lastName: element.dataset.lastName,
      tenantList: element.dataset.tenants,
      prNumber: element.dataset.prNumber || null,
      rights,
      rightsByTenant,
      timezone: element.dataset.timezone,
      stripe: {
        id: element.dataset.stripeId,
        status: element.dataset.stripeStatus,
      },
    };
    if (currentUser.rights.includes(RIGHTS.CONSULTATIONS_DIAGNOSE)) {
      managedExpertsList.push(currentUser);
    }
    store.dispatch(userUpdate({
      ...currentUser,
      managedExpertsList,
    }));
  }
  const root = createRoot(element);
  const theme = getTheme({ app: THEME_APP_NAME, branding: window.branding });
  const logoutHref = element.dataset.isanonymous ? element.dataset.logoutHref.slice(0, -1) + '?isAnonymous=true' : element.dataset.logoutHref;
  const items = [
    {
      label: _('Check my Equipment'),
      href: element.dataset.selfTestHref,
      blank: true,
    },
    {
      label: _('Support'),
      // value will be replaced by None if no config is found for tenant
      href: (element.dataset.supportHref === 'None' || !element.dataset.supportHref) ? 'https://support.parsys.com/support/tickets/new' : element.dataset.supportHref,
      blank: true,
    },
    {
      label: _('Terms and Conditions'),
      href: element.dataset.termsAndConditionsHref,
      pjax: true,
    },
    {
      label: _('Logout'),
      href: logoutHref,
      className: 'user-logout',
    },
  ];

  if (!element.dataset.isanonymous) {
    items.unshift({
      label: _('User Profile'),
      href: element.dataset.userProfileHref,
      pjax: true,
    });
  }

  root.render(
    <ErrorBoundary fallback={<ErrorFallback maxWidth='230px' />}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <ProfileDropdown
            items={items}
          />
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>,
  );
};
